import {BackOrders, Binning} from '../../common/actionTypes';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingInvoices': false,
  'loadingBackOrders': false,
  'filterBoxText': '',
  'filterPartCodeText': '',
  'filterInvoiceQuantityText': '',
  'filterInvoiceBackOrdersText': '',
  'filterNationalBackOrdersText': '',
  'filterRequester1Text': '',
  'filterRequester2Text': '',
  'filterRequester3Text': '',
  'list': [],
  'listInvoices': [],
  'filteredList': [],
  'page': [],
  'pageSize': 20,
  'pageNumber': 0,
  'downloading': false,
  'urlBackOrders': '',
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

const verifyInvoiceQuantity = (invoiceQuantity, filterText) => {
  const invoiceQuantityFormatted = parseInt(invoiceQuantity, 10);
  const filterTextFormatted = parseInt(filterText, 10);

  if (filterText && !(invoiceQuantityFormatted >= filterTextFormatted)) {
    return false;
  }
  return true;
};

const verifyInvoiceBackOrders = (invoiceBackOrders, filterText) => {
  const invoiceBackOrdersFormatted = parseInt(invoiceBackOrders, 10);
  const filterTextFormatted = parseInt(filterText, 10);

  if (filterText && !(invoiceBackOrdersFormatted >= filterTextFormatted)) {
    return false;
  }
  return true;
};

const verifyNationalBackOrders = (nationalBackOrders, filterText) => {
  const nationalBackOrdersFormatted = parseInt(nationalBackOrders, 10);
  const filterTextFormatted = parseInt(filterText, 10);

  if (filterText && !(nationalBackOrdersFormatted >= filterTextFormatted)) {
    return false;
  }
  return true;
};

const verifyFirstRequester = (firstRequesters, filterText) => {
  if (filterText && !firstRequesters.toUpperCase().includes(filterText)) {
    return false;
  }
  return true;
};

const verifySecondRequester = (secondRequesters, filterText) => {
  if ((filterText && !secondRequesters) || (secondRequesters && filterText &&
    !secondRequesters.toUpperCase().includes(filterText))) {
    return false;
  }
  return true;
};

const verifyThirdRequester = (thirdRequesters, filterText) => {
  if ((filterText && !thirdRequesters) || (thirdRequesters && filterText &&
    !thirdRequesters.toUpperCase().includes(filterText))) {
    return false;
  }
  return true;
};

const getFilteredList = (list, {box, partCode, invoiceQuantity, invoiceBackOrders,
  nationalBackOrders, requester1, requester2, requester3}) => {
  const filteredList = [];
  list.forEach((element) => {
    let filteredRow = true;
    if (box && !element.box.toUpperCase().includes(box)) {
      filteredRow = filteredRow && false;
    }
    if (partCode && !element.partCode.toUpperCase().includes(partCode)) {
      filteredRow = filteredRow && false;
    }
    filteredRow = filteredRow && verifyInvoiceQuantity(element.invoiceQuantity, invoiceQuantity);
    filteredRow = filteredRow && verifyInvoiceBackOrders(element.invoiceBackOrders, invoiceBackOrders);
    filteredRow = filteredRow && verifyNationalBackOrders(element.nationalBackOrders, nationalBackOrders);
    filteredRow = filteredRow && verifyFirstRequester(element.requesters[0], requester1);
    filteredRow = filteredRow && verifySecondRequester(element.requesters[1], requester2);
    filteredRow = filteredRow && verifyThirdRequester(element.requesters[2], requester3);
    if (filteredRow) {
      filteredList.push(element);
    }
  });

  return filteredList;
};

export const backOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [Binning.FETCHING_PENDING_INVOICES_TO_BIN]: (state, action) => ({
      ...state,
      'loadingInvoices': true,
    }),
    [Binning.FETCHED_PENDING_INVOICES_TO_BIN]: (state, action) => {
      return {
        ...state,
        'loadingInvoices': false,
        'listInvoices': action.response.data,
      };
    },
    [Binning.FETCHED_PENDING_INVOICES_TO_BIN_FAILED]: (state, action) => ({
      ...state,
      'loadingInvoices': false,
      'listInvoices': [],
    }),
    [BackOrders.FETCHING_BACK_ORDERS]: (state, action) => ({
      ...state,
      'loadingBackOrders': true,
    }),
    [BackOrders.FETCHED_BACK_ORDERS]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'filteredList': action.response.data,
      'loadingBackOrders': false,
      'page': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [BackOrders.FETCHED_BACK_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'filteredList': [],
      'page': [],
      'loadingBackOrders': false,
    }),
    [BackOrders.DOWNLOADING_BACK_ORDERS]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [BackOrders.DOWNLOADED_BACK_ORDERS]: (state, action) => ({
      ...state,
      'downloading': false,
      'urlBackOrders': action.response.data,
    }),
    [BackOrders.DOWNLOADED_BACK_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
      'urlBackOrders': '',
    }),
    [BackOrders.CHANGE_BACK_ORDERS_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'page': [...getPage(state.filteredList, action.payload, state.pageSize)],
    }),
    [BackOrders.CHANGE_BACK_ORDERS_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'page': [...getPage(state.filteredList, 0, action.payload)],
    }),
    [BackOrders.CLEAR_BACK_ORDERS_LIST]: (state, action) => ({
      ...state,
      'list': [],
      'filteredList': [],
      'page': [],
    }),
    [BackOrders.CHANGE_BOX_TEXT_FILTER]: (state, action) => {
      const box = action.payload.toUpperCase();
      const partCode = state.filterPartCodeText;
      const invoiceQuantity = state.filterInvoiceQuantityText;
      const invoiceBackOrders = state.filterInvoiceBackOrdersText;
      const nationalBackOrders = state.filterNationalBackOrdersText;
      const requester1 = state.filterRequester1Text;
      const requester2 = state.filterRequester2Text;
      const requester3 = state.filterRequester3Text;
      const filteredList = getFilteredList(state.list, {box, partCode, invoiceQuantity, invoiceBackOrders,
        nationalBackOrders, requester1, requester2, requester3});

      return ({
        ...state,
        'filterBoxText': box,
        'pageNumber': 0,
        'filteredList': [...filteredList],
        'page': [...getPage(filteredList, 0, state.pageSize)],
      });
    },
    [BackOrders.CHANGE_PART_CODE_TEXT_FILTER]: (state, action) => {
      const box = state.filterBoxText;
      const partCode = action.payload.toUpperCase();
      const invoiceQuantity = state.filterInvoiceQuantityText;
      const invoiceBackOrders = state.filterInvoiceBackOrdersText;
      const nationalBackOrders = state.filterNationalBackOrdersText;
      const requester1 = state.filterRequester1Text;
      const requester2 = state.filterRequester2Text;
      const requester3 = state.filterRequester3Text;
      const filteredList = getFilteredList(state.list, {box, partCode, invoiceQuantity, invoiceBackOrders,
        nationalBackOrders, requester1, requester2, requester3});

      return ({
        ...state,
        'filterPartCodeText': partCode,
        'pageNumber': 0,
        'filteredList': [...filteredList],
        'page': [...getPage([...filteredList], 0, state.pageSize)],
      });
    },
    [BackOrders.CHANGE_INVOICE_QUANTITY_TEXT_FILTER]: (state, action) => {
      const box = state.filterBoxText;
      const partCode = state.filterPartCodeText;
      const invoiceQuantity = action.payload;
      const invoiceBackOrders = state.filterInvoiceBackOrdersText;
      const nationalBackOrders = state.filterNationalBackOrdersText;
      const requester1 = state.filterRequester1Text;
      const requester2 = state.filterRequester2Text;
      const requester3 = state.filterRequester3Text;
      const filteredList = getFilteredList(state.list, {box, partCode, invoiceQuantity, invoiceBackOrders,
        nationalBackOrders, requester1, requester2, requester3});

      return ({
        ...state,
        'filterInvoiceQuantityText': action.payload,
        'pageNumber': 0,
        'filteredList': [...filteredList],
        'page': [...getPage([...filteredList], 0, state.pageSize)],
      });
    },
    [BackOrders.CHANGE_INVOICE_BACK_ORDERS_TEXT_FILTER]: (state, action) => {
      const box = state.filterBoxText;
      const partCode = state.filterPartCodeText;
      const invoiceQuantity = state.filterInvoiceQuantityText;
      const invoiceBackOrders = action.payload;
      const nationalBackOrders = state.filterNationalBackOrdersText;
      const requester1 = state.filterRequester1Text;
      const requester2 = state.filterRequester2Text;
      const requester3 = state.filterRequester3Text;
      const filteredList = getFilteredList(state.list, {box, partCode, invoiceQuantity, invoiceBackOrders,
        nationalBackOrders, requester1, requester2, requester3});

      return ({
        ...state,
        'filterInvoiceBackOrdersText': action.payload,
        'pageNumber': 0,
        'filteredList': [...filteredList],
        'page': [...getPage([...filteredList], 0, state.pageSize)],
      });
    },
    [BackOrders.CHANGE_NATIONAL_BACK_ORDERS_TEXT_FILTER]: (state, action) => {
      const box = state.filterBoxText;
      const partCode = state.filterPartCodeText;
      const invoiceQuantity = state.filterInvoiceQuantityText;
      const invoiceBackOrders = state.filterInvoiceBackOrdersText;
      const nationalBackOrders = action.payload;
      const requester1 = state.filterRequester1Text;
      const requester2 = state.filterRequester2Text;
      const requester3 = state.filterRequester3Text;
      const filteredList = getFilteredList(state.list, {box, partCode, invoiceQuantity, invoiceBackOrders,
        nationalBackOrders, requester1, requester2, requester3});

      return ({
        ...state,
        'filterNationalBackOrdersText': action.payload,
        'pageNumber': 0,
        'filteredList': [...filteredList],
        'page': [...getPage([...filteredList], 0, state.pageSize)],
      });
    },

    [BackOrders.CHANGE_REQUESTER_1_TEXT_FILTER]: (state, action) => {
      const box = state.filterBoxText;
      const partCode = state.filterPartCodeText;
      const invoiceQuantity = state.filterInvoiceQuantityText;
      const invoiceBackOrders = state.filterInvoiceBackOrdersText;
      const nationalBackOrders = state.filterNationalBackOrdersText;
      const requester1 = action.payload.toUpperCase();
      const requester2 = state.filterRequester2Text;
      const requester3 = state.filterRequester3Text;
      const filteredList = getFilteredList(state.list, {box, partCode, invoiceQuantity, invoiceBackOrders,
        nationalBackOrders, requester1, requester2, requester3});

      return ({
        ...state,
        'filterRequester1Text': requester1,
        'pageNumber': 0,
        'filteredList': [...filteredList],
        'page': [...getPage([...filteredList], 0, state.pageSize)],
      });
    },
    [BackOrders.CHANGE_REQUESTER_2_TEXT_FILTER]: (state, action) => {
      const box = state.filterBoxText;
      const partCode = state.filterPartCodeText;
      const invoiceQuantity = state.filterInvoiceQuantityText;
      const invoiceBackOrders = state.filterInvoiceBackOrdersText;
      const nationalBackOrders = state.filterNationalBackOrdersText;
      const requester1 = state.filterRequester1Text;
      const requester2 = action.payload.toUpperCase();
      const requester3 = state.filterRequester3Text;
      const filteredList = getFilteredList(state.list, {box, partCode, invoiceQuantity, invoiceBackOrders,
        nationalBackOrders, requester1, requester2, requester3});

      return ({
        ...state,
        'filterRequester2Text': requester2,
        'pageNumber': 0,
        'filteredList': [...filteredList],
        'page': [...getPage([...filteredList], 0, state.pageSize)],
      });
    },
    [BackOrders.CHANGE_REQUESTER_3_TEXT_FILTER]: (state, action) => {
      const box = state.filterBoxText;
      const partCode = state.filterPartCodeText;
      const invoiceQuantity = state.filterInvoiceQuantityText;
      const invoiceBackOrders = state.filterInvoiceBackOrdersText;
      const nationalBackOrders = state.filterNationalBackOrdersText;
      const requester1 = state.filterRequester1Text;
      const requester2 = state.filterRequester2Text;
      const requester3 = action.payload.toUpperCase();
      const filteredList = getFilteredList(state.list, {box, partCode, invoiceQuantity, invoiceBackOrders,
        nationalBackOrders, requester1, requester2, requester3});

      return ({
        ...state,
        'filterRequester3Text': requester3,
        'pageNumber': 0,
        'filteredList': [...filteredList],
        'page': [...getPage([...filteredList], 0, state.pageSize)],
      });
    },
    [BackOrders.CLEAR_TEXT_FILTER]: (state, action) => ({
      ...state,
      'downloading': false,
      'urlBackOrders': '',
      'filterBoxText': '',
      'filterPartCodeText': '',
      'filterInvoiceQuantityText': '',
      'filterInvoiceBackOrdersText': '',
      'filterNationalBackOrdersText': '',
      'filterRequester1Text': '',
      'filterRequester2Text': '',
      'filterRequester3Text': '',
      'pageNumber': 0,
      'filteredList': [...state.list],
      'page': [...getPage([...state.list], 0, state.pageSize)],
    }),
    [BackOrders.CLEAR_URL_BACK_ORDERS]: (state, action) => ({
      ...state,
      'downloading': false,
      'urlBackOrders': '',
    }),
  })(state, action);
};
